import { PaginationItem, PaginationItemProps } from '@mui/material';
import React from 'react';

const CustomPaginationItem: React.FC<PaginationItemProps> = (props) => {
  return (
    <PaginationItem
      {...props}
      sx={{
        marginTop: '10px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        borderColor: 'rgba(220, 231, 241, 1)',
        height: '38px',
        minWidth: '38px',
        fontSize: '14px',
        '&.Mui-selected': {
          backgroundColor: 'rgba(66, 158, 255, 1)',
          borderColor: 'rgba(66, 158, 255, 1)',
          color: '#fff',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'rgba(66, 158, 255, 1)',
          color: '#fff',
        },
        '&:hover': {
          backgroundColor: 'rgba(234, 245, 255, 1)',
          color: 'rgba(53, 55, 58, 1)',
        },
        '&.MuiPaginationItem-previousNext': {
          border: 'none',

          '.MuiPaginationItem-icon': {
            width: '1.3em',
            height: '1.3em',
          },
        },
      }}
    />
  );
};

export default CustomPaginationItem;
